import {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActionsFree";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ConditionalRender from "components/ConditionalRender";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import RouteFlyTable from "./TableRouteFly";
import FormRouteFly from "./FormRouteFly";
import axiApi from "ApiCaller";
import RouteFlyModel from "site-apps/distribution/route/RouteFlyModel";

const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
const AlertQuestion = new SwalAlertChoice({
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
});

const ViewRoutesFly = ({keyTab, setKeyTab}) => {
    // -
    // const navigate = useNavigate();
    const {t: _Tt} = useTranslation("tables");
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = "Plantillas bolseo";
        return buttonsAct;
    });
    const [itemsShown, setItemsShown] = useState([]);
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...RouteFlyModel});
    const [showForm, setShowForm] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const params = useRef({drivers: [], zones: [], waypoints: []});
    const orderingRef = useRef(new OrderingModel());
    const headersTable = useMemo(
        () => [
            {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
            {name: _Tt("common.description"), attr: 1, direction: "asc", active: false, disabled: true},
            {name: _Tt("users.driver"), attr: 2, direction: "asc", active: false},
            {name: _Tt("routes.zone"), attr: 3, direction: "asc", active: false},
            {name: _Tt("common.created"), attr: 4, direction: "asc", active: false},
        ],
        [_Tt],
    );

    useEffect(() => {
        onMounted(keyTab);
        return () => {
            unsubscribeEvent("view:route-fly:apply-filters", customEventApplyFilters);
        };
    }, [keyTab]);

    const onMounted = (keyTab_) => {
        // only when click in this tab: templates
        if (keyTab_ !== "templates") return;
        // end if is initialized
        if (itemsShown.length) {
            applyFilters();
            return;
        }
        // --- INITIALIZING ---
        subscribeEvent("view:route-fly:apply-filters", customEventApplyFilters);
        const buttons = {...buttonsTB};
        // -
        buttons.title = "Plantillas bolseo";
        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;
        // -
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        // -
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB({...buttons});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {...RouteFlyModel};
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => applyFilters();

        filters.current.filter = () => {
            applyFilters();
        };
        fetchGetData();
    };

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/distribution/routes/fly-tippings/");
        if (resp.data) {
            if (resp.data.items) {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
            }
            if (resp.data.params) {
                params.current = {...resp.data.params};
            }
        }
        setIsLoading(false);
    };

    const onClickAdd = () => {
        setItem({...RouteFlyModel});
        setShowForm(true);
        subscribeEvent("view:route-fly:apply-filters", customEventApplyFilters);
    };

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        const id = parseInt(items.current.chosen[0]);
        const route = {...(items.current.showed.find((item) => item.id === id) || RouteFlyModel)};
        setItem({...route});
        setShowForm(true);
        subscribeEvent("view:route-fly:apply-filters", customEventApplyFilters);
    };

    const onClickDelete = () => {
        AlertQuestion.warning(
            "Se eliminarán las plantillas seleccionadas",
            `Se borraran los ${items.current.chosen.length} seleccionados`,
        ).then((resp) => {
            if (resp.isConfirmed) {
                let ids = items.current.getChosenIds();
                setIsLoading(true);
                axiApi
                    .delete("/api/distribution/routes/fly-tipping/delete/", {data: {ids}})
                    .then((resp) => {
                        if (resp.data.status) {
                            Alert.success("Eliminadas", "Plantillas eliminadas correctamente");
                        }
                    })
                    .catch((error) => {
                        const msg = error.response?.data?.message || "Error al eliminar las plantillas";
                        Alert.error("Error", msg);
                    })
                    .finally(() => {
                        items.current.clearChosen();
                        const buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        setButtonsTB(buttons);
                        setIsLoading(false);
                        applyFilters();
                    });
            }
        });
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/routes/fly-tippings/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                pagerModelRef.current.paging.setPager(resp.data);
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const customEventApplyFilters = (e) => {
        applyFilters();
        unsubscribeEvent("view:route-fly:apply-filters", customEventApplyFilters);
    };

    return (
        <>
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="sticky-top" style={{top: "72px"}} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <div className="col-12">
                <LoaderSpinner isLoading={isLoading}>
                    <RouteFlyTable
                        items={items}
                        itemsShown={itemsShown}
                        setItemsShown={setItemsShown}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        orderingRef={orderingRef}
                    />
                </LoaderSpinner>
            </div>
            <ConditionalRender condition={showForm}>
                <FormRouteFly show={showForm} setShow={setShowForm} item={item} items={items} setItem={setItem} params={params} />
            </ConditionalRender>
        </>
    );
};
export default ViewRoutesFly;
